import React from "react"
import Heading from "../common/heading/Heading"
import "./HomeAccreditation.css"

const partnersList = [
    { name: "Partner Universities", path: "/images/partners/partner-1.png" },
    { name: "Industry Councils", path: "/images/partners/partner-2.png" },
    { name: "Skill Bodies", path: "/images/partners/partner-3.png" },
    { name: "AISECT", path: "/images/partners/partner-5.png" }
];

const HomeAccreditation = () => {
    return (
        <section className="accreditation-section">
            <div className="container">
                <Heading
                    subtitle="Recognized by global education authorities."
                    title="Our Accreditation & Partners"
                />

                <div className="accreditation-slider-container">
                    <div className="accreditation-track">
                        {/* Double the array for infinite scroll effect */}
                        {[...partnersList, ...partnersList].map((partner, idx) => (
                            <div key={idx} className="accreditation-logo-box">
                                <img src={partner.path} alt={partner.name} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HomeAccreditation
